module.exports = __webpack_public_path__ + "static/img/sxzy.b325edf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sxzy.png
// module id = G6UW
// module chunks = 1